import React, { useState, useEffect, Fragment, useContext } from "react";
import {
  BrowserRouter as Router,
  Link,
  useLocation,
  withRouter,
} from "react-router-dom";
import styled from "styled-components";
import { XBEappearer } from "./XBEappearer";
import { XbeContext } from './CardsPage';
import { Integration } from "./integration/Integration";
import { AdminSwitcher } from './integration/AdminSwitcher';
import { Icon, Tooltip } from 'xsolla-uikit';
// import { MaterialIcon } from './integration/MaterialIcon';
import MaterialIcon from 'material-icons-react';
import { CMScardActions } from '../cms/CMScardActions';

export const publisherUrl = (filters, utm) => {
  return utm
    ? `https://publisher.xsolla.com/signup?utm_campaign=${utm}&filters=${filters}`
    : `https://publisher.xsolla.com/signup?filters=${filters}`;
};



export const XBEcard = (props) => {

  const {
    step,
    back = ()=>void(0),

    tags,
    pa,
    salesCardId,
    filters,
    utm,
  } = {...props}

  // useEffect(() => {}, [props]);

  const checkIfShow = (filters) => {
    let shw = false;

    const checkStage = (arr) => {
      let res = false;
      arr.forEach((oneFilt) => {
        res = filters.indexOf(oneFilt) === -1 ? res : true;
      });
      return res;
    };

    const filtFilt = (arr, arrF) => {
      let filtersOfOneTypeArray = arrF.filter(
        (oneFilt) => arr.indexOf(oneFilt) !== -1
      );
      return checkStage(filtersOfOneTypeArray);
    };

    let stage = filtFilt(
      ["pre_launch", "early_access", "live_game"],
      props["tags"]
    );
    let mon = filtFilt(
      ["microtransactions", "premium", "subscriptions"],
      props["tags"]
    );
    let platf = filtFilt(["pc_mac", "web", "console", "mobile"], props["tags"]);

    shw = stage && mon && platf ? true : false;

    // if (shw) props['countAsVisible']()

    return shw;
  };

  const context = useContext(XbeContext);

  return (
    <Fragment>
      {context["editId"] === props["salesCardId"] && <Integration {...props} />}

      {Boolean(step) && <AdminSwitcher
                  active='landing'
                  cardId={props["match"]["params"]["cardId"]}
                />}


      {Boolean(step) && <Integration {...props} />}

      <XBEappearer
        shown={checkIfShow(props["filters"])}
        // style={{ opacity: checkIfShow(props) ? 1 : 0.2 }}
        className={"xbe_card0"}
        // className={`xbe_card0 ${
        //   props['appearance'] === 'l' ? ' xbe_card0--f' : ''
        // }`}
      >
        <XBEcardInner {...props} />
      </XBEappearer>
    </Fragment>
  );
};

const XBEcardInnerI = (props) => {
  const {
    pa,

    language = "en",

    filters,
    appearance = "l",
    utm,
    id = 2051,
    salesCardId = 8,
    imageUrl = "//cdn3.xsolla.com/img/misc/images/36f8e5c1fca71f5a393cf35a26b0d637.jpg",
    badgeText = "INCREASE PAYMENTS COVERAGE",
    title = "Boost revenue by expanding payments in South Korea",
    description = "Be among the first companies to adopt advanced tech and conquer the Korean market with new digital wallets like Toss, NaverPay, and KakaoPay.",
    learnMoreUrl = "https://xsolla.com/blog/payments/1154/boost-revenue-by-unlocking-south-korea",
    integrationTimeText = "Setup time: less than 3 minutes",
    callToAction = null,
    proposalText = "You see this card because you can earn more by selling in South Korea",
    postponed = false,
    project_id = 43087,
    project_name = "project cta",

    history,
    match,
    location,
  } = { ...props };

  const context = useContext(XbeContext);

  return (
    <Fragment>

    {/* <p>utm: {utm},</p>
    <p>id: {id},</p>
    <p>salesCardId: {salesCardId},</p>
    <p>imageUrl: {imageUrl},</p>
    <p>badgeText, {badgeText}</p>
    <p>title, {title}</p>
    <p>description, {description}</p>
    <p>learnMoreUrl, {learnMoreUrl}</p>
    <p>integrationTimeText, {integrationTimeText}</p>
    <p>callToAction  {callToAction}= 'Get started',</p>
    <p>proposalText, {proposalText}</p>
    <p>postponed, {postponed}</p>
    <p>project_id, {project_id}</p>
    <p>project_name, {project_name}</p> */}


      <div className="xbe_card">
        <div className="xbe_card_pic0">
          {appearance === "l" && (
            <div className="xbe_card_pic">
              <div className="xbe_card_pic_grad"></div>

              <div
                className="xbe_card_pic_abs"
                style={{
                  backgroundImage: `url(${imageUrl})`,
                }}
              />
            </div>
          )}
        </div>
        <div className="xbe_card_flex">
          <div className="xbe_card_content">
            <div className="xbe_card_line">
              <div className="xbe_card_badge0">
                {language === "en"
                  ? badgeText
                  : `${props[`badgeText_${language}`]}`}
              </div>
            </div>
            <div className="xbe_card_line">
              <div className="xbe_card_title">
                <div className="xbe_card_title">
                  {language === "en" ? title : `${props[`title_${language}`]}`}
                </div>
              </div>
            </div>
            <div className="xbe_card_line">
              <div className="xbe_card_desc">
                <div className="text-block-27">
                  {language === "en"
                    ? description
                    : `${props[`description_${language}`]}`}
                </div>
              </div>
            </div>
          </div>
          <div className="xbe_card_line">
            <div className="xbe_card_cta0">
              <a
                target="_parent"
                // href={publisherUrl(filters, utm)}
                href={`/card/${salesCardId}`}
                className="xbe_card_cta xbe_card_cta--1"
              >
                <div>
                  {language === "en"
                    ? props["callToAction__title"]
                    : `${props[`callToAction__title_${language}`]}`}
                </div>
              </a>

              {/* <a href={learnMoreUrl} className="xbe_card_cta xbe_card_cta--2">
                Learn more
              </a> */}

              <a
                className="xbe_card_cta xbe_card_cta--2"
                onClick={() =>
                  history.push(
                    `/card/${salesCardId}?step=1&filters=${context["filters"].toString()}`
                  )
                }
              >
                Learn more
              </a>


            </div>
            {!!integrationTimeText && (
              <div className="xbe_card_time">
                <div>{integrationTimeText}</div>
              </div>
            )}
          </div>
        </div>
      </div>
      {Boolean(pa) && <CMScardActions {...props} />}
    </Fragment>
  );
};

export const XBEcardInner = withRouter(XBEcardInnerI);




const CSScardFix = styled.div`
  /* display: flex; */
  /* flex-direction: column; */
  flex-grow: 1;
  &:hover .xbe_card_cta--1 {
    background: #337bf3;
    color: white;
  }
`;

export const CssIcon = styled.span`
  font-size: ${({ size }) => (size ? `${size}px` : "32px")};
  margin-right: ${({ left }) => (left ? `6px` : "0px")};
  font-family: "Materialicons";
  height: 1em;
  display: inline-flex;
  line-height: 1em;
  /* width: 44px;
  height: 44px; */
`;
